import { render, staticRenderFns } from "./MarcaManage.vue?vue&type=template&id=f686dcd8&scoped=true"
import script from "./MarcaManage.vue?vue&type=script&lang=js"
export * from "./MarcaManage.vue?vue&type=script&lang=js"
import style0 from "./MarcaManage.vue?vue&type=style&index=0&id=f686dcd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f686dcd8",
  null
  
)

export default component.exports